import React, { useContext, useState } from "react";
import "./Header.css";
import { Nav, Navbar } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import Fire_Lottie from "../animation/fire_lottie/Fire_Lottie";
import Profile from "../common_components/profile/Profile";
import { Context } from "../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="header-background">
      <div className="container custom-nav-container">
        <div className="inner-navbar">
          <div className="container">
            <Navbar
              expand="lg"
              expanded={expanded}
              onToggle={(isOpen) => setExpanded(isOpen)}
              className="glass-nav mobile-header"
            >
              {/* Toggle */}
              <Navbar.Toggle aria-controls="glass-nav" />

              {/* Logo */}
              <Navbar.Brand
                as={NavLink}
                to="/home"
                className="brand"
                onClick={() => setExpanded(false)}
              >
                <img
                  src="images/logo/logo.png"
                  alt="Spirulina Logo"
                  className="navbar-logo"
                />
              </Navbar.Brand>

              <div
                className="bell_icon_div d-lg-none d-block"
                onClick={() => navigate("/notification")}
              >
                <FontAwesomeIcon icon={faBell} className="bell_icon" />
              </div>

              {/* Mobile Profile */}
              <div
                className="nav-profile-1"
                onClick={() => navigate("/profile")}
              >
                <Profile />
              </div>

              {/* Collapse */}
              <Navbar.Collapse
                id="glass-nav"
                onClick={() => setExpanded(false)}
              >
                <Nav className=" nav-center">
                  <Nav.Link
                    as={NavLink}
                    to="/home"
                    end
                    onClick={() => setExpanded(false)}
                  >
                    <button className="navbar-button">Homepage</button>
                  </Nav.Link>

                  <Nav.Link
                    as={NavLink}
                    to="/about"
                    onClick={() => setExpanded(false)}
                  >
                    <button className="navbar-button">About Us</button>
                  </Nav.Link>

                  <Nav.Link
                    as={NavLink}
                    to="/products"
                    onClick={() => setExpanded(false)}
                  >
                    <button className="navbar-button">Products</button>
                  </Nav.Link>

                  <Nav.Link
                    as={NavLink}
                    to="/contact"
                    onClick={() => setExpanded(false)}
                  >
                    <button className="navbar-button">Contact Us</button>
                  </Nav.Link>
                </Nav>

                {/* Right Section */}
                <div className="nav-right">
                  <div
                    className="bell_icon_div"
                    onClick={() => navigate("/notification")}
                  >
                    <FontAwesomeIcon icon={faBell} className="bell_icon" />
                  </div>
                  <div className="refer">
                    <div className="lottie_holder">
                      <Fire_Lottie />
                    </div>
                    <div>
                      <div>Refer & Earn More</div>
                      <div className="sub">with Exciting Rewards</div>
                    </div>
                  </div>
                  <div
                    className="nav-profile-2 navbar-profile"
                    onClick={() => navigate("/profile")}
                  >
                    <Profile />
                  </div>
                </div>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
